module.exports = __webpack_public_path__ + "images/f6fe61428ea88fc6acddf68c33d595cb.svg";